import Head from "next/head"
import styles from "@/styles/about-us.module.scss"
import DefaultLayout from "@/components/DefaultLayout"
import ObserverSection from '@/components/ObserverSection'
import Image from "next/image"
import { Divider } from 'antd';

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function AboutUs() {

  return (
    <>
      <Head>
        <title>
          广州市杰钡利科技有限公司
        </title>

        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby"
        />
        <meta
          name="description"
          content="Australia's #1 online shopping website! Cheap bargains & discounts with the top online shopping Australia store! From furniture, to toys & hobbies, to appliances & pet supplies -- we've got it all, with free shipping on selected items!"
        />
      </Head>

      <DefaultLayout>
        <div className={styles["page-about-us"]}>
          <Image 
            className={styles['banner']}
            alt={'banner'}
            width={1920}
            height={639}
            priority={true}
            src={`${imageDomain}/about-us/banner.png`}
          ></Image>

          <div className={styles['container']}>
            <div className={styles['english-title']}>Brief Introduction</div>
            <div className={styles['title']}>公司简介</div>

            <div className={styles['desc']}>
              杰钡利科技是一家专注做进出口跨境电商的企业，是跨境电商的开拓者。目前集团员工人数超过400名，公司总部坐落于广州，团队分布于全球各地，在澳洲、新西兰、菲律宾、北京、上海、西安等地先后设立了分部。
            </div>

            <div className={styles['desc']}>
              杰钡利科技拥有产品自主开发能力，通过多个海外自营网站与eBay、Amazon等一级电商平台开店销售各类产品，致力将中国制造的优质产品带到全球各地。出口部主营产品涵盖生活家居、健身器材、家用电器、儿童玩具、3C科技、运动户外、宠物用品等全领域品类拓展；17大品类、900个细分品类、10万个SKU，齐全的类目和丰富的产品为客户提供优质的购物体验。进口部作为品牌的总代、经销及代运营等电商新零售服务合作伙伴，致力于成为大健康最信赖的合伙人。二十年来集团实现了多元化的业务发展，除跨境电商外，还有B2B礼品制定服务及战略联营等品牌合作。集团年度总销售额突破12亿。
            </div>

            <div className={styles['desc']}>
              公司有二十多年的跨境电商行业经验，拥有专业的采购开发、运维、市场营销、IT研发及物流等团队，利用自研系统高效地解决了多品类、多供应商、多平台、多仓库、多国家的跨境交易与客户服务；同时，公司还组建专业健全的客服团队为客户提供优质贴心的售前售后服务。为了提升配送的质量和速度，集团配备了海内外仓储物流体系，除澳洲和新西兰建立海外仓库外，在澳洲，新西兰，美国和哥伦比亚均有第三方合作的仓储服务，实现货物本地配送服务。
            </div>

            <div className={styles['desc']}>
              目前，公司正持续高速发展中，坚守“打破世界信息差，共享全球优质产品”的使命，致力成为一家不断迭代、多元发展的全球化企业。以创造力、输出力、不设限的核心价值观不断努力成长，继续深耕跨境电商领域，实现公司及人才的双丰收。
            </div>

            <ObserverSection 
              customClassName={styles['logistics-box-static']} 
              customActiveClassName={styles['logistics-box-active']}
            >
              <div className={styles['logistics-box']}>
                <Image 
                  className={styles['logistics-bg']}
                  alt={'logistics-bg'}
                  width={1200}
                  height={276}
                  src={`${imageDomain}/about-us/logistics-bg.png`}
                ></Image>
                <Image 
                  className={styles['logistics-location']}
                  alt={'logistics-location'}
                  width={1200}
                  height={276}
                  src={`${imageDomain}/about-us/logistics-location.png`}
                ></Image>
                <Image 
                  className={styles['logistics-airplan']}
                  alt={'logistics-airplan'}
                  width={1200}
                  height={276}
                  src={`${imageDomain}/about-us/logistics-airplan.png`}
                ></Image>
              </div>
            </ObserverSection>
            
            <Divider style={{ borderColor: '#999999' }} />

            <div className={styles['english-title']}>Development History</div>
            <div className={styles['title']}>发展历程</div>
          </div>

          <ObserverSection 
            customClassName={styles['banner-box-static']} 
            customActiveClassName={styles['banner-box-active']}
          >
            <div className={styles['banner-box']}>
              <Image 
                className={styles['development-history-bg']}
                alt={'development-history-bg'}
                width={1920}
                height={1032}
                src={`${imageDomain}/about-us/development-history-bg.png`}
              ></Image>

              <Image 
                className={styles['development-history-text']}
                alt={'development-history-text'}
                width={1920}
                height={850}
                src={`${imageDomain}/about-us/development-history-text.png`}
              ></Image>
            </div>
          </ObserverSection>
        </div>
      </DefaultLayout>
    </>
  )
}